import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useOrganization } from '../../context/OrganizationContext'
import { useToast } from '../../context/ToastContext'
import type { ApiClientError } from '../../services/apiHelpers'
import { OrganizationForm } from './OrganizationForm'

export default function OrganizationCreate() {
  const navigate = useNavigate()
  const { createOrganization, clearError, error } = useOrganization()
  const { pushToast } = useToast()
  const [submitting, setSubmitting] = useState(false)
  const [serverErrors, setServerErrors] = useState<Record<string, string>>({})

  useEffect(() => {
    clearError()
  }, [clearError])

  async function handleSubmit(payload) {
    clearError()
    setServerErrors({})
    setSubmitting(true)
    try {
      const created = await createOrganization(payload)
      pushToast({ message: 'Organization created', variant: 'success' })
      navigate(`/organizations/${created.id}`, { replace: true })
    } catch (e) {
      const fieldErrors = (e as ApiClientError).fieldErrors
      if (fieldErrors && Object.keys(fieldErrors).length > 0) {
        setServerErrors(fieldErrors)
      }
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="space-y-4">
      {error ? (
        <div className="rounded-xl border border-red-100 bg-red-50 px-4 py-3 text-sm text-red-800">
          {error}
        </div>
      ) : null}
      <OrganizationForm
        mode="create"
        initialValues={undefined}
        onSubmit={handleSubmit}
        onCancel={() => navigate(-1)}
        submitting={submitting}
        serverErrors={serverErrors}
      />
    </div>
  )
}
